const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 31.633 31.528"
      className="stroke-current"
    >
      <g
        id="Group_9523"
        data-name="Group 9523"
        transform="matrix(0.966, -0.259, 0.259, 0.966, -657.978, -131.172)"
      >
        <line
          id="Line_231"
          data-name="Line 231"
          x2="4.2"
          y2="6.918"
          transform="translate(618.3 324.582)"
          fill="none"
          strokeLinecap="round"
          strokeWidth={3}
        />
        <g
          id="Ellipse_49"
          data-name="Ellipse 49"
          transform="translate(600 303)"
          fill="#fff"
          strokeWidth={3}
        >
          <circle cx={12} cy={12} r={12} stroke="none" />
          <circle cx={12} cy={12} r="10.5" fill="none" />
        </g>
      </g>
    </svg>
  )
}

export default SearchIcon
